var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fy-step"},_vm._l((_vm.steplist),function(item,index){return _c('div',{key:'key-'+index,staticClass:"item",class:[(index!=0)?'centers': '',((index+1)==_vm.type)?'active':''],style:('width:'+_vm.stepitemwidth)},[_vm._v("\n    "+_vm._s(item)+"\n    "),(index!==_vm.steplistlength)?_c('div',{staticClass:"sanjiao"}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }